function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M17 11h4v10H3V7h4V4l5-2 5 2zM5 9v2h2V9zm4 0v2h2V9zm0-4v2h2V5zm4 8v2h2v-2zm0-8v2h2V5zm4 8v2h2v-2zM5 13v2h2v-2zm4 0v2h2v-2zm4 4v2h2v-2zm0-8v2h2V9zm4 8v2h2v-2zM5 17v2h2v-2zm4 0v2h2v-2z",
  fillRule: "evenodd",
  fill: "currentColor"
});

var SvgLocationCity = function SvgLocationCity(props) {
  return React.createElement("svg", _extends({
    height: 24,
    width: 24
  }, props), _ref);
};

export default SvgLocationCity;